<template>
    <div class="l-login-span" @click="onLogout" v-if="!isTribe">
      <img src="../images/tuichu.png" class="l-login-icon" />
      退出登录
    </div>
</template>
<script>
import UsercenterModel from '@/models/usercenter'
import version from '@/utils/version'
const usercenterModel = new UsercenterModel()
export default {
  name: 'l-logout',
  data() {
    return {
      isTribe: version.isLILYTribeAPP(),
    }
  },
  props: {
    user: {},
  },
  methods: {
    onLogout() {
      usercenterModel
        .logout(this.user.id)
        .then(() => {
          localStorage.removeItem('questionEnd')
          localStorage.removeItem(window.$USERKEY)
          sessionStorage.removeItem('CLOSE_STATUS' + '_' + this.user.id)
          // window.location.href =
          //   window.location.protocol + "//" + window.location.host + "/login";
          // window.location.href = process.env.VUE_APP_BASE_URL + '/login'
          // window.$dayuan1997.login(encodeURIComponent(window.location.href));
          window.$dayuan1997.login(
            encodeURIComponent(
              window.location.protocol + '//' + window.location.host
            )
          )
        })
        .catch((error) => {
          this.$lPrompt({
            message: error.msg,
            successTxt: '确定',
          })
        })
    },
  },
}
</script>
<style scoped>
.l-login-span{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 163px;
  height: 49px;
  background: #7282e4;
  border-radius: 23px;
  box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #665fce inset; 
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}
.l-login-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  vertical-align: middle;
}
</style>
